export default "__VITE_ASSET__BkS2RECO__"